const USER_ID_NAMES = new Set(['userid', 'user-id', 'user_id', 'user id'])

export function isInjectedUserIdParameter(name: string): boolean {
  return USER_ID_NAMES.has(name.trim().toLowerCase())
}

function isHiddenParameter(p: { name: string; visible?: boolean }): boolean {
  if (p.visible === false) return true
  if (p.visible === undefined) return isInjectedUserIdParameter(p.name)
  return false
}

export function partitionInjectedParameters<T extends { name: string; visible?: boolean }>(params: T[]) {
  const visible: T[] = []
  const injected: T[] = []
  for (const p of params) {
    (isHiddenParameter(p) ? injected : visible).push(p)
  }
  return { visible, injected }
}

/** True when the SQL has no placeholders yet. */
export function shouldShowParameterPlaceholderHint<T extends { name: string }>(params: T[]): boolean {
  return params.length === 0
}
